define('Stock.Status', [
    'Stock.Status.View',
    'Stock.Status.Model',
    'ProductDetails.QuickView.View',
    'Cart.AddToCart.Button.View',
    'SC.Configuration',
    'underscore',
    'Utils'
],
function StockStatus(
    StockStatusView,
    StockStatusModel,
    ProductDetailsQuickViewView,
    CartAddToCartButtonView,
    Configuration,
    _,
    Utils
) {
    'use strict';

    var multipleStock = Configuration.get('customizations.stockStatus.multipleIds');
    var fullResults = [];

    var isItAProductView = function (view) {
        return view &&
            view.attributes &&
            view.attributes.id &&
            view.attributes.id.indexOf('ProductDetails') !== -1;
    };

    return {
        mountToApp: function mountToApp(container) {
            var model = new StockStatusModel();
            var stockforToggleModel = new StockStatusModel();
            var pdp = container.getComponent('PDP');
            var fetchModel;
            var searchStatusInformation;
            var getFullStatusInformation;
            var checkItemQuantity;
            var firstQty;
            var itemSelected;
            var stockSelected;

            var modalCurrentView;
            var currentView;
            var currentViewModelItem;
            var modalCurrentViewItem;

            // NOTE: Avoid service POST for SEO to prevent 500 errors and it's not needed in SEO context. 
            if (Utils.isPageGenerator()) {
                return;
            }

            fetchModel = function fetchModelFunction(itemArray, action) {
                var modelToUse;
                console.log('ACTION', action);

                if (action === 'full') {
                    modelToUse = stockforToggleModel;
                } else {
                    modelToUse = model;
                }
                modelToUse.fetch({
                    data: JSON.stringify(itemArray),
                    type: 'POST',
                    contentType: 'application/json'
                }).then(function thenFetch(data) {
                    var innerModel;
                    var prop;
                    prop = action === 'full' ? 'itemAvailability' : 'qtyAvailability';
                    if (data) {
                        if (multipleStock) {
                            fullResults = data;
                        }
                        CartAddToCartButtonView.removeExtraContextProperty('nonStock');
                        CartAddToCartButtonView.addExtraContextProperty('nonStock', 'string', function haveStock() {
                            if (pdp.getItemInfo() && pdp.getItemInfo().fulfillmentChoice === 'pickup') {
                                return false;
                            }
                            if (multipleStock) {
                                if (pdp.getItemInfo() && (_.size(pdp.getSelectedMatrixChilds()) === 1 || _.size(pdp.getAllMatrixChilds()) === 0)) {
                                    firstQty = pdp.getItemInfo().quantity;
                                    if (_.size(pdp.getSelectedMatrixChilds()) === 1) {
                                        if (_.first(pdp.getSelectedMatrixChilds()).custitem_corresponding_sku_num_id) {
                                            itemSelected = _.first(pdp.getSelectedMatrixChilds()).custitem_corresponding_sku_num_id;
                                        } else {
                                            itemSelected = _.first(pdp.getSelectedMatrixChilds()).internalid;
                                        }
                                    } else if (_.size(pdp.getAllMatrixChilds()) === 0) {
                                        itemSelected = pdp.getItemInfo().item.internalid;
                                    }
                                    // stockSelected = _.findWhere(data, { item: parseInt(itemSelected, 0) });
                                    stockSelected = _.find(data, function findItem(obj) {
                                        return obj.item === itemSelected.toString() || obj.item === parseInt(itemSelected, 10);
                                    });
                                    if (stockSelected && (stockSelected.quantity < parseInt(firstQty, 10))) {
                                        return true;
                                    }
                                    return false;
                                }
                                if (data[0].statusId === '4') return true;
                            }
                            if (!multipleStock) {
                                if (data[0].statusId === '4') {
                                    return true;
                                }
                            }
                            return false;
                        });
                    }
                    modalCurrentView = pdp.application.getLayout().modalCurrentView;
                    currentView = pdp.application.getLayout().currentView;
                    currentViewModelItem = currentView.model.get('item');

                    if (isItAProductView(modalCurrentView)) {
                        innerModel = modalCurrentView && modalCurrentView.model && modalCurrentView.model;
                        modalCurrentViewItem = modalCurrentView && modalCurrentView.model && modalCurrentView.model.get('item');
                        if (modalCurrentViewItem) {
                            modalCurrentViewItem.get('_matrixChilds').each(function forEachChildItem(childItemModel) {
                                childItemModel.set(prop, _(data).findWhere({
                                    item: childItemModel.id
                                }), { silent: true });
                            });

                            if (_(data).findWhere({ item: String(modalCurrentViewItem.id) })) {
                                modalCurrentViewItem.set(prop, _(data).findWhere({
                                    item: String(modalCurrentViewItem.id)
                                }), { silent: true });
                            } else if (_(data).findWhere({ item: modalCurrentViewItem.id })) {
                                modalCurrentViewItem.set(prop, _(data).findWhere({
                                    item: modalCurrentViewItem.id
                                }), { silent: true });
                            }
                            innerModel.trigger('availabilitiesReadyModel');
                        }


                        modalCurrentView.trigger('availabilitiesReadyView');
                        modalCurrentView.renderChild('MainActionView');
                        modalCurrentView.renderChild('Stock.Status');
                        modalCurrentView.renderChild('Product.Sku');
                        modalCurrentView.renderChild('InStock.ToggleQuickView');
                    } else {
                        innerModel = currentView.model;
                        currentViewModelItem.get('_matrixChilds').each(function forEachChildItem(childItemModel) {
                            childItemModel.set(prop, _(data).findWhere({
                                item: childItemModel.id
                            }), { silent: true });
                        });

                        if (_(data).findWhere({ item: String(currentViewModelItem.id) })) {
                            currentViewModelItem.set(prop, _(data).findWhere({
                                item: String(currentViewModelItem.id)
                            }), { silent: true });
                        } else if (_(data).findWhere({ item: currentViewModelItem.id })) {
                            currentViewModelItem.set(prop, _(data).findWhere({
                                item: currentViewModelItem.id
                            }), { silent: true });
                        }

                        innerModel.trigger('availabilitiesReadyModel');
                        currentView.trigger('availabilitiesReadyView');
                        currentView.renderChild('MainActionView');
                        currentView.renderChild('Stock.Status');
                        currentView.renderChild('Product.Stock.Info');
                        currentView.renderChild('Product.Sku');
                        currentView.renderChild('InStock.ToggleMobile');
                        // currentView.renderChild('Product.Options');
                    }
                });
                modelToUse.clear({ 'silent': true });
            };

            getFullStatusInformation = function getFullStatusInformationFunction() {
                var itemArray = [];
                var itemId;
                if (_.size(pdp.getAllMatrixChilds()) > 0) {
                    _.each(pdp.getAllMatrixChilds(), function eachMatrix(matrixChild) {
                        if (matrixChild.custitem_corresponding_sku_num_id) {
                            itemArray.push({ item: matrixChild.custitem_corresponding_sku_num_id });
                        } else {
                            itemArray.push({ item: matrixChild.internalid });
                        }
                    });
                    fetchModel(itemArray, 'full');
                } else {
                    itemId = pdp.getItemInfo().item.internalid;
                    fetchModel([{ item: itemId }], 'full');
                }
            };

            searchStatusInformation = function searchStatusInformationFunction(action) {
                var itemSel;
                var itemObject = {};
                var itemArray = [];
                var itemId;
                var itemQty;
                var layout = pdp.application.getLayout();
                // NOTE: YMAN popup opens a quick view on current PIP. Refer to _currentView which is always correct view in the context.
                // eslint-disable-next-line no-underscore-dangle
                var curView = layout && layout._currentView;
                var actualQty = curView && curView.model && curView.model.get('quantity');
                var fromPDP;
                var fromCart;
                /* eslint-disable */
                var pastQty = curView && curView.model && curView.model._previousAttributes && curView.model._previousAttributes.quantity;
                /* eslint-enable */
                model.set('showErrorQty', false, { 'silent': true });
                if (pdp.getItemInfo().quantity < 100) {
                    fromPDP = actualQty !== pastQty && action === 'afterQuantityChange';
                    fromCart = !actualQty && !pastQty && action === 'afterQuantityChange';
                    if (fromPDP || fromCart || action !== 'afterQuantityChange') {
                        if (pdp.getSelectedMatrixChilds().length === 1) {
                            itemSel = _.filter(pdp.getItemInfo().item.matrixchilditems_detail, function filterItems(itemFiltered) {
                                return itemFiltered.itemid === _.first(pdp.getSelectedMatrixChilds()).itemid;
                            });
                            if (itemSel) {
                                itemObject.item = itemSel[0].custitem_corresponding_sku_num_id || itemSel[0].internalid;
                                itemObject.quantity = pdp.getItemInfo() ? pdp.getItemInfo().quantity : null;
                                itemArray.push(itemObject);
                                model.set('params', itemArray, { silent: true });
                                fetchModel(itemArray, action);
                            }
                        } else if (pdp.getItemInfo('item').item.itemtype === 'InvtPart') {
                            itemId = pdp.getItemInfo('item') ? pdp.getItemInfo('item').item.internalid : null;
                            itemQty = pdp.getItemInfo().quantity;
                            fetchModel([{ 'item': itemId, 'quantity': itemQty }], action);
                        } else {
                            itemId = pdp.getItemInfo('item') ? pdp.getItemInfo('item').item.internalid : null;
                            itemQty = pdp.getItemInfo().quantity;
                            fetchModel([{ 'item': itemId, 'quantity': itemQty }], action);
                        }
                    }
                } else {
                    model.set('showErrorQty', true, { silent: true });
                    CartAddToCartButtonView.removeExtraContextProperty('nonStock');
                    CartAddToCartButtonView.addExtraContextProperty('nonStock', 'string', function haveStock() {
                        if (pdp.getItemInfo() && pdp.getItemInfo().fulfillmentChoice === 'pickup') {
                            return false;
                        }
                        return true;
                    });
                    // NOTE: YMAN popup opens a quick view on current PIP. Refer to _currentView which is always correct view in the context.
                    // eslint-disable-next-line no-underscore-dangle
                    pdp.application.getLayout()._currentView.renderChild('MainActionView');
                    if (pdp.application.getLayout().modalCurrentView) {
                        pdp.application.getLayout().modalCurrentView.renderChild('MainActionView');
                    }
                }
            };

            if (pdp) {
                pdp.addChildViews('ProductDetails.Full.View', {
                    'Stock.Status': {
                        'stock_status_information': {
                            childViewIndex: 1,
                            childViewConstructor: function childViewConstructor() {
                                return new StockStatusView({
                                    model: model,
                                    pdp: pdp
                                });
                            }
                        }
                    }
                });
                pdp.on('afterShowContent', function afterShowContent() {
                    // Avoid trigger when current view is ICDS popup to prevent errors.
                    if (pdp.getItemInfo()) {
                        getFullStatusInformation();
                        searchStatusInformation('afterShowContent');
                    }
                });

                pdp.on('afterQuantityChange', function afterQuantityChange() {
                    // Avoid trigger when current view is ICDS popup to prevent errors.
                    if (pdp.getItemInfo()) {
                        searchStatusInformation('afterQuantityChange');
                    }
                });

                pdp.on('afterOptionSelection', function afterOptionSelection() {
                    // Avoid trigger when current view is ICDS popup to prevent errors.
                    if (pdp.getItemInfo()) {
                        searchStatusInformation('afterOptionSelection');
                    }
                });
            }

            // Adding child view to the quick view
            _(ProductDetailsQuickViewView.prototype).extend({
                childViews: _.extend(ProductDetailsQuickViewView.prototype.childViews || {}, {
                    'Stock.Status': function childViewStockStatus() {
                        return new StockStatusView({
                            model: model,
                            pdp: pdp
                        });
                    }
                })
            });
        }
    };
});

